// extracted by mini-css-extract-plugin
module.exports = {"BenefitsMessage":"BenefitsMessage_BenefitsMessage__p419W","BenefitsModal":"BenefitsMessage_BenefitsModal__8paJK"};